import React, { useState } from 'react'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'

import User from 'EurestoClass/User'
import Formulaire from 'Components/Formulaire'

import { Grid } from '@material-ui/core'

import moment from 'moment'

import { usePersistFn } from 'ahooks'

const columns = [{
    header: 'Id',
    id: 'id',
    show: false
},
{
    header: '#id AR',
    width: 80,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.json.data.idVente}</Grid>,
    type: 'number',
    id: 'idVente'
},
{
    header: 'Date vente',
    width: 120,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{moment(d.date_vente).format('DD/MM/YY HH:mm')}</Grid>,
    type: 'date',
    id: 'dateValidation'
},
{
    header: <span style={{ float: 'left' }}>{EurestoI18n.t('commun:Contact')}</span>,
    sortable: false,
    type: 'string',
    Cell: (row) => {
        const contact = row.json.data.contact
        return <span style={{ float: 'left' }}>
            <b className={row.status === 0 && 'EurestoError--text' || ''}>{(contact.civilite ? (contact.civilite + ' ') : '') + contact.nom + ' ' + contact.prenom}</b>
        </span>
    }
},
{
    header: <span>{EurestoI18n.t('commun:Montant Total')}</span>,
    sortable: false,
    type: 'string',
    Cell: row => row.montant_total + ' €'
},
]

const columnsDetail = [{
    header: 'Id',
    id: 'id',
    show: false,
},
{
    header: 'Description',
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.description}</Grid>,
    type: 'number',
    id: 'description'
},
{
    header: 'Montant Total',
    width: 120,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.prixTotal || d.montantTotal}</Grid>,
    type: 'number',
    id: 'prixTotal'
},
{
    header: 'Quantité',
    width: 120,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.quantite}</Grid>,
    type: 'number',
    id: 'prixTotal'
},
{
    header: 'Catégorie',
    width: 120,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.categorie}</Grid>,
    type: 'number',
    id: 'categorie'
},
{
    header: 'Formule',
    width: 120,
    Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
        justify={"center"}>{d.formule}</Grid>,
    type: 'number',
    id: 'formule'
},
]


const isAllow = {
    add: false, update: false, delete: false
}

export default React.memo(props => {
    const [vente, setVente] = useState(null)
    const [key, setKey] = useState(Utils.getRandomNumber())

    const setAllow = usePersistFn((row) => ({
    }))
    const onClick = usePersistFn((row) => {
        setVente(row.json.data.produits)
        setKey(Utils.getRandomNumber())
    })
    const onClickVente = usePersistFn((row) => {
    })

    return <React.Fragment>
        <Formulaire
            infinityScroll={true}
            isAllow={isAllow}
            onClick={onClick}
            useActionRequest={{
                get: () => {

                }
            }}
            handleAction={{ get: () => { } }}
            maxHeight={User.CalculHeight.getHeightWanted(0, ' / 2 ')}
            setAllow={setAllow}
            showForm={false}
            search={props.search || 'alliance_reseaux_' + (props.name || '') + User.Entite.get().id}
            title={props.title}
            module={Constants.module.ALLIANCE_RESEAUX}
            requete={Constants.donnee.reservation} columns={columns} />
        {vente && <Formulaire
            key={key}
            actionRequest={{
                get: () => {

                }
            }}
            isAllow={isAllow}
            handleAction={{ get: () => { } }}
            onClick={onClickVente}
            setAllow={setAllow}
            maxHeight={User.CalculHeight.getHeightWanted(0, ' / 2 ')}
            showForm={false}
            title={'Detail'}
            datas={vente} columns={columnsDetail} />}
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/AllianceReseaux/Page/Recherche/index.js